import React from "react"
import HeroSection from "../slices/heroSection"
import TextSection from "../slices/textSection"
import ImageWithTextSection from "../slices/imageWithTextSection"
import IllustrationCollection from "../slices/illustrationCollection"
import EmbedWithText from "../slices/embedWithText"
import Accordian from "../slices/accordian"
import HeroEmbed from "../slices/heroEmbed"
import Partners from "../slices/partners"

const PageSlicesContainer = ({ slices }) => {
  return slices.map((slice, index) => {
    const res = (() => {
      switch (slice.slice_type) {
        case "hero_section":
          return <HeroSection key={index} slice={slice} />
        case "text_section":
          return <TextSection key={index} slice={slice} />
        case "image_with_text":
          return <ImageWithTextSection key={index} slice={slice} />
        case "illustration_collection":
          return <IllustrationCollection key={index} slice={slice} />
        case "accordian":
          return <Accordian key={index} slice={slice} />
        case "embed_with_text":
          return <EmbedWithText key={index} slice={slice} />
        case "hero_embed":
          return <HeroEmbed key={index} slice={slice} />
        case "partners":
          return <Partners key={index} slice={slice} />
        default:
          return
      }
    })()
    return res
  })
}

export default PageSlicesContainer
